export var DEVICE_DESKTOP = 'DESKTOP';
export var DEVICE_TABLET = 'TABLET';
export var DEVICE_MOBILE = 'MOBILE';
export var SUCCESS = 'success';
export var ERROR = 'error';
export var INFO = 'info';
export var LOADING = 'loading';
export var WARNING = 'warning';